import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/**
 * 路由保护组件
 * 检查用户是否已登录，未登录则重定向到登录页
 */
const PrivateRoute = ({ children }) => {
  const location = useLocation();
  const isAdmin = localStorage.getItem('isAdmin') === 'true';
  const loginDate = localStorage.getItem('loginDate');
  const today = new Date().toDateString();

  // 检查登录状态和日期是否有效
  if (!isAdmin || loginDate !== today) {
    // 如果是日期过期导致的，清除登录状态
    if (isAdmin && loginDate !== today) {
      localStorage.removeItem('isAdmin');
      localStorage.removeItem('token');
      localStorage.removeItem('loginDate');
    }

    // 重定向到登录页，并保存当前尝试访问的路径，以便登录后跳回
    // 增加 message 字段，用于在登录页显示提示
    return <Navigate to="/admin/login" state={{ from: location, message: loginDate !== today && isAdmin ? "登录已过期，请重新登录" : "请先登录以访问管理后台" }} replace />;
  }

  return children;
};

export default PrivateRoute;
